import type { ConnectivitySource, ConnectivityState } from '@sl/core';

/**
 * The web adapter for `ApiClient.connectivity()` (ARCH §8.2): `navigator.onLine` plus the `online` /
 * `offline` window events. Handed to `HttpApiClient`; a demo account ignores real connectivity (REQ-246 AC5).
 */
export function browserConnectivity(win: Window = window): ConnectivitySource {
  const read = (): ConnectivityState => (win.navigator.onLine === false ? 'offline' : 'online');
  return {
    get: read,
    subscribe: (listener) => {
      const notify = () => listener(read());
      win.addEventListener('online', notify);
      win.addEventListener('offline', notify);
      return () => {
        win.removeEventListener('online', notify);
        win.removeEventListener('offline', notify);
      };
    },
  };
}
